const MarginChildren = ({ className, children }) => {
  return <div className={`[&>*]:mb-default last:mb-0 ${className}`}>{children}</div>;
};

export default MarginChildren;
